import mixpanel from 'mixpanel-browser'
import { Env } from '../controller/constant'

mixpanel.init(Env.mixPanelToken, { ignore_dnt: true })

let actions = {
    identify: (id) => {
        mixpanel.identify(id)
    },
    reset: () => {
        mixpanel.reset()
    },
    alias: (id) => {
        mixpanel.alias(id)
    },
    track: (name, props) => {
        mixpanel.track(name, props)
    },
    people: {
        set: (props) => {
            mixpanel.people.set(props)
        },
    },
}

export let Mixpanel = actions